import { EmployeeInvitationStatusTypes } from 'types/electionService';
import { reinviteSubscriber } from 'api/operations/userService';
import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { getRootStoreInstance } from 'store/rootStore';
import { runInAction } from 'mobx';
import { EmployeeActionObject, generalEmployeeActions } from './actionRules';
import { InviteEmployeeAction } from './types';

/** Shared by enrollment and RFQ add-employees — composed with `generalEmployeeActions`. */
export const inviteEmployeeActions: EmployeeActionObject[] = [
  {
    type: InviteEmployeeAction.SEND_INVITATION,
    name: 'Send Invitation',
    showForStatuses: [EmployeeInvitationStatusTypes.NOT_YET_INVITED, EmployeeInvitationStatusTypes.ADD_MAIL],
    handler: (context): void => {
      if (!context.ui.openSendInvitationModal) {
        throw new Error('No openSendInvitationModal callback provided for SEND_INVITATION action!');
      }
      context.ui.openSendInvitationModal();
    },
  },
  {
    type: InviteEmployeeAction.RESEND_INVITATION,
    name: 'Re-send Invitation',
    showForStatuses: [EmployeeInvitationStatusTypes.INVITED],
    handler: async (context): Promise<void> => {
      await reinviteSubscriber({
        firstName: context.static.employeeData.common.firstName,
        lastName: context.static.employeeData.common.lastName,
        email: context.static.employeeData.email!,
        userType: context.static.employeeData.subSERole,
        groupId: context.static.groupId,
        subscriberId: context.static.employeeData.id,
      });
      toastManager.addToast('Reminder sent successfully!', ToastColorTypes.SUCCESS);
    },
  },
];

export const getStandardActionsWithSelfEnrollFeature = (
  pageActions: EmployeeActionObject[] = [],
): EmployeeActionObject[] => {
  return runInAction(() => {
    const rootStore = getRootStoreInstance();

    return [
      ...pageActions,
      ...(rootStore.domainStoreV2.showSelfEnrollFeature ? inviteEmployeeActions : []),
      ...generalEmployeeActions,
    ];
  });
};
